export default function CourseCTA() {
  const scrollToContact = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const el = document.getElementById('contact-section');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <section id="course-cta" className="py-10 sm:py-12 bg-[#3D1203]">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-12 flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6 text-center sm:text-left">
        <p className="text-white font-semibold text-base sm:text-lg leading-snug">
          Ready to build genuine cultural capability in your team?
        </p>
        <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto flex-shrink-0">
          <button
            onClick={scrollToContact}
            className="w-full sm:w-auto px-6 py-3 bg-[#BA3D03] text-white rounded-lg font-semibold hover:bg-[#E48523] transition-all shadow whitespace-nowrap cursor-pointer text-sm"
          >
            Request Company Pricing
          </button>
        </div>
      </div>
    </section>
  );
}
